module.exports = __webpack_public_path__ + "static/media/greentea.da392abc.jpg";